import { Grid } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { ModalComponent } from '../../../widgets';
import BotonComponent from '../../dashboard/components/BotonNuevo';
import { setActivoUsuariosAction } from '../../usuario/usuarios/UsuariosAction';
import FormNuevoUsuariosComponent from '../../usuario/usuarios/components/FormNuevoUsuarios';
import { allDocentesAction, setActivoDocentesAction } from './DocentesAction';
import TodosCarnetsDocentes from './TodosCarnetsDocentes';
import ListadoDocentes from './components/ListadoDocentes';

const DocentesView = () => {
  const dispatch = Redux.useDispatch();

  const docentesStore = Redux.useSelector((state) => state.docentes);
  const loginStore = Redux.useSelector((state) => state.login);

  const [openModalForm, setOpenModalForm] = React.useState(false);
  const [modalCarnets, setModalCarnets] = React.useState(false);

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        <BotonComponent
          click={async () => {
            await setActivoDocentesAction(dispatch, null);
            await setActivoUsuariosAction(dispatch, null);
            setOpenModalForm(true);
          }}
          green
          mr={2}
          addIcon
        />
        <BotonComponent
          click={async () => {
            await setActivoDocentesAction(dispatch, null);
            await allDocentesAction(dispatch, docentesStore.params);
          }}
          disabled={docentesStore.all.length === 0 && docentesStore.loadingAll}
          white
          text={docentesStore.loadingAll ? 'Actualizando...' : 'Actualizar'}
          refreshIcon
          mr={2}
        />

        {loginStore.isRoot && (
          <BotonComponent
            text="CARNETS"
            click={() => {
              if (docentesStore.selects.length === 0) {
                alert('Falta seleccionar los docentes');
                return;
              }
              setModalCarnets(!modalCarnets);
            }}
            white={!modalCarnets}
            mr={2}
          />
        )}
      </Grid>
      <Grid item md={12}>
        <ListadoDocentes setOpenModalForm={(val) => setOpenModalForm(val)} />
      </Grid>
      <ModalComponent
        id="modalFormDocentes"
        title={`${
          docentesStore.activo
            ? `Editar ${docentesStore.activo.nombre}`
            : 'Nuevo docente'
        }`}
        open={openModalForm}
        maxWidth="lg"
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        <FormNuevoUsuariosComponent
          activo={docentesStore.activo}
          setOpenModalForm={(val) => setOpenModalForm(val)}
          isUsuarios={false}
          isPerfiles={false}
          isTeacher
        />
      </ModalComponent>
      <ModalComponent
        id="modal-carnets-codeqr"
        title="Descargar Carnet y Códigos QR"
        open={loginStore.isRoot && modalCarnets}
        maxWidth="xl"
        onClose={() => setModalCarnets(!modalCarnets)}
      >
        <TodosCarnetsDocentes />
      </ModalComponent>
    </Grid>
  );
};

export default DocentesView;
